import { useState, useEffect } from "react";
import DraftCreator from "./DraftCreator";
import DraftDetails from "./DraftDetails";
import "../styles/DraftsPage.css";
import { useLocation, useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
//const basePath = location.pathname.split("/")[1];

const DraftsPage = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = location.pathname.split("/")[1]; 

  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [showCreator, setShowCreator] = useState(false);
  const [selectedDraft, setSelectedDraft] = useState(null);
  
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [createdByFilter, setCreatedByFilter] = useState("ALL");

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);



/* ================= FETCH DRAFTS (ADMIN + USER) ================= */
  const fetchDrafts = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(`${API_BASE}/drafts`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!res.ok) {
        throw new Error("Failed to fetch drafts");
      }

      const data = await res.json();
      setDrafts(data);
    } catch (err) {
      console.error("FETCH DRAFTS ERROR:", err);
      setError("Unable to load drafts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrafts();
  }, []);

  /* ================= CREATE DRAFT (REFRESH LIST) ================= */
  const handleCreateDraft = async (draftData) => {
    try {
      const res = await fetch(`${API_BASE}/drafts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(draftData),
      });

      if (!res.ok) {
        throw new Error("Draft creation failed");
      }

      setShowCreator(false);
      fetchDrafts(); // 🔥 refresh list
    } catch (err) {
      console.error("CREATE DRAFT ERROR:", err);
      alert("Failed to create draft");
    }
  };

  /* ================= FILTER + PAGINATION ================= */

/* 	const filteredDrafts = drafts.filter((draft) => {
	  if (statusFilter === "ALL") return true;
	  return draft.batch_status === statusFilter;
	});

	const displayedDrafts = filteredDrafts.slice(0, pageSize); */

	// Get unique users for "Created By" dropdown
	const uniqueUsers = [
	  ...new Set(drafts.map((d) => d.user_name).filter(Boolean)),
	];

	// Apply filters
	const filteredDrafts = drafts.filter((draft) => {
	  const statusMatch =
		statusFilter === "ALL" || draft.batch_status === statusFilter;

	  const userMatch =
		createdByFilter === "ALL" || draft.user_name === createdByFilter;

	  return statusMatch && userMatch;
	});

	// Pagination
	const totalPages = Math.ceil(filteredDrafts.length / pageSize);

	const paginatedDrafts = filteredDrafts.slice(
	  (currentPage - 1) * pageSize,
	  currentPage * pageSize
	);


  return (
    <div className="drafts-page">
      {/* ===== HEADER ===== */}
      <div className="drafts-header">
        <h2>Draft Generator</h2>
        <button className="create-btn" onClick={() => setShowCreator(true)}>
          Create Patent Draft
        </button>
      </div>

      {/* ===== STATES ===== */}
      {loading && <p>Loading drafts...</p>}
      {error && <p className="error">{error}</p>}

      {/* ===== FILTERS ===== */}
		<div className="draft-filters">

		  {/* Status Filter */}
		  <div>
			<label>Status:</label>
			<select
			  value={statusFilter}
			  onChange={(e) => {
				setStatusFilter(e.target.value);
				setCurrentPage(1);
			  }}
			>
			  <option value="ALL">All</option>
			  <option value="IN_PROGRESS">In Progress</option>
			  <option value="COMPLETED">Completed</option>
			  <option value="FAILED">Failed</option>
			</select>
		  </div>

		  {/* Created By Filter */}
		  <div>
			<label>Created By:</label>
			<select
			  value={createdByFilter}
			  onChange={(e) => {
				setCreatedByFilter(e.target.value);
				setCurrentPage(1);
			  }}
			>
			  <option value="ALL">All</option>

			  {uniqueUsers.map((user) => (
				<option key={user} value={user}>
				  {user}
				</option>
			  ))}
			</select>
		  </div>

		  {/* Page Size */}
		  <div>
			<label>Show:</label>
			<select
			  value={pageSize}
			  onChange={(e) => {
				setPageSize(Number(e.target.value));
				setCurrentPage(1);
			  }}
			>
			  <option value={25}>25</option>
			  <option value={50}>50</option>
			  <option value={100}>100</option>
			</select>
		  </div>
		
		{/* ===== PAGINATION ===== */}
		{totalPages > 1 && (
		  <div className="pagination">

			<button
			  disabled={currentPage === 1}
			  onClick={() => setCurrentPage((p) => p - 1)}
			>
			  Prev
			</button>

			<span>
			  Page {currentPage} of {totalPages}
			</span>

			<button
			  disabled={currentPage === totalPages}
			  onClick={() => setCurrentPage((p) => p + 1)}
			>
			  Next
			</button>

		  </div>
		)}
		</div>
		{/* ===== TABLE ===== */}

      {!loading && drafts.length > 0 && (
        <table className="drafts-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Input File</th>
              <th>Rows</th>
			  <th>Draft Type</th>
              <th>Created By</th>
              <th>Created Date</th>
			  <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedDrafts.map((draft) => (
              <tr key={draft.job_batch_id}>
                <td>{draft.job_batch_id}</td>
                <td>{draft.input_file}</td>
                <td>{draft.start_number}-{draft.end_number}</td>
				<td>{draft.draft_type}</td>
                <td>{draft.user_name || user?.user_name}</td>
                <td>
                  {draft.createdAt
                    ? new Date(draft.createdAt).toLocaleString()
                    : "-"}
                </td>
				<td
                style={{
                  color:
                    draft.batch_status === "COMPLETED"
                      ? "green"
                      : draft.batch_status === "FAILED"
                      ? "red"
                      : "black",
                  fontWeight: 600,
                }}
              >
                {draft.batch_status}
              </td>
                <td>
                  <button
                    className="view-btn"
                    onClick={() => setSelectedDraft(draft)}
                  >
                    View Details
                  </button>
				  <button
					className="view-btn"
					onClick={() => navigate(`/${basePath}/draft-status/${draft.job_batch_id}`)}
				  >
					 || Execution Status
				  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
	  
	  {/* ===== PAGINATION ===== */}
		{totalPages > 1 && (
		  <div className="pagination">

			<button
			  disabled={currentPage === 1}
			  onClick={() => setCurrentPage((p) => p - 1)}
			>
			  Prev
			</button>

			<span>
			  Page {currentPage} of {totalPages}
			</span>

			<button
			  disabled={currentPage === totalPages}
			  onClick={() => setCurrentPage((p) => p + 1)}
			>
			  Next
			</button>

		  </div>
		)}


      {/* ===== EMPTY ===== */}
      {!loading && drafts.length === 0 && <p>No drafts found.</p>}

      {/* ===== DETAILS ===== */}
      {selectedDraft && (
        <DraftDetails
          draft={selectedDraft}
          onClose={() => setSelectedDraft(null)}
        />
      )}

      {/* ===== CREATOR ===== */}
      {showCreator && (
        <DraftCreator
          onClose={() => setShowCreator(false)}
			onCreate={handleCreateDraft}
			onJobCreated={() => {
			  setShowCreator(false);   // close modal
			  fetchDrafts();         // refresh list / status page
			}}  
        />
      )}
    </div>
  );
};

export default DraftsPage;
